import {TranslateService} from '@ngx-translate/core';
import {ImportModuleMediaPatternError} from '../../core/definitions/import-module';

/** The longest media match pattern the backend accepts. */
const MEDIA_PATTERN_MAX_LENGTH = 200;

/** The codes the backend refuses a custom media match pattern with. */
export const MEDIA_PATTERN_ERROR_CODES: readonly string[] = [
  'media_pattern_empty', 'media_pattern_too_long', 'media_pattern_invalid',
];

/** A rejected response's media pattern error, `null` when its body carried
 * none of `MEDIA_PATTERN_ERROR_CODES`. */
export function mediaPatternErrorOf(rejection: any): ImportModuleMediaPatternError | null {
  const code = rejection?.errorCode;
  return MEDIA_PATTERN_ERROR_CODES.includes(code) ? {code, position: rejection.errorPosition ?? null} : null;
}

/** `error` as the operator reads it, the invalid pattern's position
 * counted from 1. A code of none of `MEDIA_PATTERN_ERROR_CODES` reads as
 * itself. */
export function mediaPatternErrorText(translate: TranslateService, error: ImportModuleMediaPatternError): string {
  switch (error.code) {
    case 'media_pattern_empty':
      return translate.instant('TRANS__IMPORT__MEDIA_MATCH_PATTERN_REQUIRED');
    case 'media_pattern_too_long':
      return translate.instant('TRANS__IMPORT__MEDIA_MATCH_PATTERN_TOO_LONG', {max: MEDIA_PATTERN_MAX_LENGTH});
    case 'media_pattern_invalid':
      return error.position === null
        ? translate.instant('TRANS__IMPORT__MEDIA_MATCH_PATTERN_INVALID_NO_POSITION')
        : translate.instant('TRANS__IMPORT__MEDIA_MATCH_PATTERN_INVALID', {position: error.position + 1});
    default:
      return error.code;
  }
}
